/* =========================================================
   PRODUCT LOADED
========================================================= */

document.addEventListener('product:loaded', function (e) {
  const context = e.detail?.container || document;
  initializeSubscriptionSelection(context);
});


/* =========================================================
   SYNC SUBSCRIPTION RADIO
========================================================= */

function syncSubscriptionRadio(btn) {
  const allRadios = document.querySelectorAll(
    'input[name="subscription-plan"]'
  );

  allRadios.forEach(radio => {
    radio.checked = false;
    radio.removeAttribute('checked');
  });

  let radio = btn.querySelector(
    'input[name="subscription-plan"]'
  );

  if (!radio) {
    const sellingPlanId = btn.dataset.sellingPlanId || '';
    const value = btn.dataset.subscriptionValue || sellingPlanId;

    if (value) {
      radio = Array.from(allRadios).find(
        input => String(input.value) === String(value)
      );
    }
  }

  if (radio) {
    radio.checked = true;
    radio.setAttribute('checked', 'checked');

    radio.dispatchEvent(
      new Event('change', {
        bubbles: true
      })
    );
  }
}


/* =========================================================
   GET VALID QUANTITY
========================================================= */

function getSubscriptionQuantity(value, fallback = 1) {
  const parsed = parseInt(String(value ?? '').trim(), 10);

  if (Number.isFinite(parsed) && parsed > 0) {
    return parsed;
  }

  const fallbackParsed = parseInt(
    String(fallback ?? '').trim(),
    10
  );

  return Number.isFinite(fallbackParsed) && fallbackParsed > 0
    ? fallbackParsed
    : 1;
}


/* =========================================================
   INITIALIZE DEFAULT SUBSCRIPTION OPTION
========================================================= */

function initializeSubscriptionSelection(context = document) {
  let selectedBtn = context.querySelector(
    '.custom-subscription-btn.is-selected'
  );

  if (!selectedBtn) {
    selectedBtn = context.querySelector(
      '.custom-subscription-btn'
    );
  }

  if (!selectedBtn) {
    console.warn('No .custom-subscription-btn found');
    return;
  }

  document.querySelectorAll('.custom-subscription-btn').forEach(el => {
    el.classList.remove('is-selected');
    el.setAttribute('aria-pressed', 'false');
  });

  selectedBtn.classList.add('is-selected');
  selectedBtn.setAttribute('aria-pressed', 'true');

  syncSubscriptionRadio(selectedBtn);

  const variantId = selectedBtn.dataset.variantId;
  const sellingPlanId =
    selectedBtn.dataset.sellingPlanId || '';

  const qty = getSubscriptionQuantity(
    selectedBtn.dataset.qty,
    1
  );

  selectedBtn.dataset.qty = qty;

  if (!variantId) {
    console.warn(
      'Subscription option has no variant ID'
    );
    return;
  }

  /*
   * IMPORTANT:
   * Default state is subscription.
   */
  const checkoutBtn = document.getElementById(
    'add-to-checkout'
  );

  if (checkoutBtn) {
    checkoutBtn.dataset.type = 'subscribe';
    checkoutBtn.dataset.variantId = variantId;
    checkoutBtn.dataset.spId = sellingPlanId;
    checkoutBtn.dataset.qty = qty;
  }

  switchPlan(
    variantId,
    sellingPlanId,
    qty
  );
}


/* =========================================================
   SUBSCRIPTION OPTION CLICK
========================================================= */

document.addEventListener('click', function (e) {

  const btn = e.target.closest(
    '.custom-subscription-btn'
  );
   if (btn) {
    document.querySelectorAll('.otp-sec').forEach(function (OtpBtn) {
      OtpBtn.classList.remove('is-selected');
      OtpBtn.classList.remove('selected');
    });
  }

  if (!btn) return;

  e.preventDefault();

  const variantId =
    btn.dataset.variantId;

  const sellingPlanId =
    btn.dataset.sellingPlanId || '';

  const qty =
    getSubscriptionQuantity(
      btn.dataset.qty,
      1
    );


  /*
   * Remove selected state
   */
  document
    .querySelectorAll(
      '.custom-subscription-btn'
    )
    .forEach(el => {

      el.classList.remove(
        'is-selected'
      );

      el.setAttribute(
        'aria-pressed',
        'false'
      );

      const radio =
        el.querySelector(
          'input[name="subscription-plan"]'
        );

      if (radio) {
        radio.checked = false;
        radio.removeAttribute('checked');
      }
    });


  /*
   * Select subscription
   */
  btn.classList.add(
    'is-selected'
  );

  btn.setAttribute(
    'aria-pressed',
    'true'
  );


  /*
   * Select subscription radio
   */
  const radio =
    btn.querySelector(
      'input[type="radio"][name="subscription-plan"]'
    );

  if (radio) {

    radio.checked = true;

    radio.setAttribute(
      'checked',
      'checked'
    );

    radio.dispatchEvent(
      new Event('change', {
        bubbles: true
      })
    );
  }


  /*
   * Update main checkout button
   */
  const checkoutBtn =
    document.getElementById(
      'add-to-checkout'
    );

  if (checkoutBtn) {

    checkoutBtn.dataset.type =
      'subscribe';

    checkoutBtn.dataset.variantId =
      variantId;

    checkoutBtn.dataset.spId =
      sellingPlanId;

    checkoutBtn.dataset.qty =
      qty;

    console.log(
      'SUBSCRIPTION option selected:',
      {
        type: 'subscribe',
        variantId: variantId,
        sellingPlanId: sellingPlanId,
        qty: qty
      }
    );
  }


  if (!variantId) return;


  switchPlan(
    variantId,
    sellingPlanId,
    qty
  );
});


/* =========================================================
   SUBSCRIPTION PLAN
========================================================= */

function switchPlan(vId, spId, counter) {

  /*
   * Sync radio again when plan changes
   */
  const selectedSubscription =
    document.querySelector(
      `.custom-subscription-btn[data-variant-id="${vId}"]`
    );

  if (selectedSubscription) {

    syncSubscriptionRadio(
      selectedSubscription
    );

    const selectedQty =
      getSubscriptionQuantity(
        counter,
        selectedSubscription.dataset.qty
      );

    selectedSubscription.dataset.qty =
      selectedQty;
  }


  let bottleElement =
    document.getElementById(
      'plan_' + vId
    );


  if (!bottleElement) {

    bottleElement =
      document.querySelector(
        `.subscription-label[data-variant-id="${vId}"]`
      );
  }


  if (!bottleElement) {

    console.error(
      'Subscription plan element not found for variant:',
      vId
    );

    /*
     * Keep checkout state intact.
     */
    updateAddToCheckoutAttrs();

    return;
  }


  /* =======================================================
     GALLERY
  ======================================================= */

  const mediaId =
    bottleElement.getAttribute(
      'data-media-id'
    );

  if (mediaId) {

    const gallery =
      $('.product-gallery')[0];

    if (gallery) {

      updateGalleryByMedia(
        mediaId,
        gallery
      );
    }
  }


  /* =======================================================
     SELECTED PLAN UI
  ======================================================= */

  document
    .querySelectorAll('.subscription-label')
    .forEach(el => {

      el.classList.remove(
        'selected-plan'
      );
    });

  bottleElement.classList.add(
    'selected-plan'
  );


  /* =======================================================
     PRICING
  ======================================================= */

  const subscriptionName =
    bottleElement.getAttribute(
      'data-selling-plan-name'
    ) || '';

  const subscriptionFinalPrice =
    bottleElement.getAttribute(
      'data-selling-price'
    ) || '';

  const subscriptionComparePrice =
    bottleElement.getAttribute(
      'data-compare-price'
    ) || '';


  if (subscriptionFinalPrice) {

    $('.subscription-main-price').html(
      '$' + subscriptionFinalPrice
    );

    $('.product-final-price').html(
      '&nbsp;<span class="blk-dot">.</span>&nbsp;$' +
      subscriptionFinalPrice
    );
  }


  if (subscriptionComparePrice) {

    $('.subscription-compare-price').html(
      '<del>$' +
      subscriptionComparePrice +
      '</del>'
    );
  }


  updatePlanInfo();

  /*
   * IMPORTANT:
   * This function now respects one-time mode.
   */
  updateAddToCheckoutAttrs();
}


/* =========================================================
   CUSTOM VARIANT BUTTON - ONE TIME
========================================================= */

document.addEventListener('click', function (e) {
  const btn = e.target.closest('.custom-variant-btn');

  // If one-time variant button is clicked,
  // remove subscription selected states
  if (btn) {
    document.querySelectorAll('.subscription-label').forEach(function (subsBtn) {
      subsBtn.classList.remove('is-selected');
      subsBtn.classList.remove('selected-plan');
    });
    document.querySelectorAll('input[name="subscription-plan"]').forEach(function (radio) {
      radio.checked = false;
      radio.removeAttribute('checked');
    });
  }
  
  if (!btn) return;

  e.preventDefault();

  const variantId = btn.dataset.variantId;
  const qty = getSubscriptionQuantity(btn.dataset.qty, 1);

  if (!variantId) {
    console.warn('No variant ID found on variant button');
    return;
  }

  /*
   * Remove selected state from all
   * one-time variant buttons
   */
  const group = btn.closest('.variants-row') || document;

  group.querySelectorAll('.custom-variant-btn').forEach(function (el) {
    el.setAttribute('aria-pressed', 'false');
    el.classList.remove('is-selected');
  });

  /*
   * Select clicked one-time option
   */
  btn.setAttribute('aria-pressed', 'true');
  btn.classList.add('is-selected');

  /*
   * IMPORTANT:
   * Store the one-time variant directly
   * on the checkout button.
   */
  const checkoutBtn = document.getElementById('add-to-checkout');

  if (checkoutBtn) {
    checkoutBtn.dataset.type = 'oneTime';

    checkoutBtn.dataset.variantId = variantId;

    /*
     * Remove subscription selling plan.
     */
    checkoutBtn.dataset.spId = '';

    checkoutBtn.dataset.qty = qty;

    /*
     * Store the active one-time variant
     * separately as an additional safeguard.
     */
    checkoutBtn.dataset.oneTimeVariantId = variantId;
    checkoutBtn.dataset.oneTimeQty = qty;

    console.log('ONE-TIME option selected:', {
      type: 'oneTime',
      variantId: variantId,
      qty: qty,
      sellingPlanId: ''
    });
  }

  /*
   * Update gallery / price / variant UI
   */
  switchBottle(variantId, qty);
});


/* =========================================================
   SWITCH BOTTLE / VARIANT
========================================================= */

function switchBottle(n, counter) {

  const bottleElement =
    document.getElementById(
      'bottle_' + n
    );


  if (!bottleElement) {

    console.error(
      'Bottle element not found for quantity:',
      n
    );

    /*
     * Even if UI element is missing,
     * keep the checkout variant synced.
     */
    syncOneTimeCheckoutVariant(n, counter);

    return;
  }


  /* =======================================================
     GALLERY
  ======================================================= */

  const mediaId =
    bottleElement.getAttribute(
      'data-media-id'
    );

  if (mediaId) {

    const gallery =
      $('.product-gallery')[0];

    if (gallery) {

      updateGalleryByMedia(
        mediaId,
        gallery
      );
    }
  }


  /* =======================================================
     PRICING
  ======================================================= */

  const currentPriceValue =
    bottleElement.getAttribute(
      'data-price'
    );

  const oldPriceValue =
    bottleElement.getAttribute(
      'data-compare-price'
    );


  if (oldPriceValue) {

    $('.one-time-com-price').html(
      '<del>' +
      oldPriceValue +
      '</del>'
    );
  }


  if (currentPriceValue) {

    $('.product-final-price').html(
      '&nbsp;<span class="blk-dot">.</span>&nbsp;' +
      currentPriceValue
    );
  }


  /* =======================================================
     HIGHLIGHT SELECTED VARIANT
  ======================================================= */

  document
    .querySelectorAll('.variant')
    .forEach(el => {

      el.classList.remove(
        'selected'
      );
    });


  bottleElement.classList.add(
    'selected'
  );


  /* =======================================================
     RADIO
  ======================================================= */

  const radio =
    document.getElementById(
      'qty-' + n
    );


  if (radio) {

    radio.checked = true;

    radio.dispatchEvent(
      new Event('change', {
        bubbles: true
      })
    );

  } else {

    console.warn(
      'Radio input not found for variant:',
      n
    );
  }


  /*
   * IMPORTANT:
   * Make sure the checkout button still
   * contains the one-time variant.
   */
  syncOneTimeCheckoutVariant(
    n,
    counter
  );
}


/* =========================================================
   SYNC ONE-TIME CHECKOUT VARIANT
========================================================= */

function syncOneTimeCheckoutVariant(
  variantId,
  qty
) {

  const checkoutBtn =
    document.getElementById(
      'add-to-checkout'
    );

  if (!checkoutBtn) {
    return;
  }


  /*
   * Only update this way when the CTA
   * is currently in one-time mode.
   *
   * This is the main fix for the bug.
   */
  if (
    checkoutBtn.dataset.type !==
    'oneTime'
  ) {
    return;
  }


  const finalQty =
    getSubscriptionQuantity(
      qty,
      checkoutBtn.dataset.oneTimeQty || 1
    );


  checkoutBtn.dataset.type =
    'oneTime';

  checkoutBtn.dataset.variantId =
    variantId;

  checkoutBtn.dataset.spId =
    '';

  checkoutBtn.dataset.qty =
    finalQty;

  checkoutBtn.dataset.oneTimeVariantId =
    variantId;

  checkoutBtn.dataset.oneTimeQty =
    finalQty;


  console.log(
    'ONE-TIME CHECKOUT SYNC:',
    {
      type: 'oneTime',
      variantId: variantId,
      qty: finalQty,
      sellingPlanId: ''
    }
  );
}


/* =========================================================
   UPDATE PLAN INFORMATION
========================================================= */

function updatePlanInfo() {

  const selectedPlan =
    document.querySelector(
      '.selected-plan .selling_plan_frequency'
    );


  if (!selectedPlan) {
    return;
  }


  const text =
    selectedPlan.textContent
      .trim()
      .toLowerCase();


  const qtyEl =
    document.querySelector(
      '.no-of-qty'
    );

  const daysEl =
    document.querySelector(
      '.no-of-days'
    );


  if (!qtyEl || !daysEl) {
    return;
  }


  let days = 30;


  if (
    text.includes('monthly') ||
    text.includes('every 30')
  ) {

    days = 30;

  } else if (
    text.includes('bi-monthly') ||
    text.includes('every 60')
  ) {

    days = 60;

  } else if (
    text.includes('quarterly') ||
    text.includes('every 90')
  ) {

    days = 90;

  } else if (
    text.includes('4 months') ||
    text.includes('every 120')
  ) {

    days = 120;

  } else if (
    text.includes('6 months') ||
    text.includes('every 180')
  ) {

    days = 180;
  }


  daysEl.textContent =
    `${days} Days`;


  const currentQtyText =
    qtyEl.textContent.toLowerCase();


  const isPouchPage =
    currentQtyText.includes('pouch');


  const calculatedQty =
    Math.max(
      1,
      Math.round(days / 30)
    );


  if (isPouchPage) {

    qtyEl.textContent =
      `${calculatedQty} Pouch${
        calculatedQty > 1 ? 'es' : ''
      }`;

  } else {

    qtyEl.textContent =
      `${calculatedQty} Bottle${
        calculatedQty > 1 ? 's' : ''
      }`;
  }
}


/* =========================================================
   UPDATE ADD TO CHECKOUT ATTRIBUTES
========================================================= */

function updateAddToCheckoutAttrs() {

  const btn =
    document.getElementById(
      'add-to-checkout'
    );


  if (!btn) {
    return;
  }


  /*
   * =======================================================
   * IMPORTANT FIX
   *
   * If the user selected ONE-TIME,
   * do NOT overwrite the checkout button
   * with the subscription variant.
   * =======================================================
   */

  if (
    btn.dataset.type ===
    'oneTime'
  ) {

    const oneTimeVariantId =
      btn.dataset.oneTimeVariantId ||
      btn.dataset.variantId;


    const oneTimeQty =
      getSubscriptionQuantity(
        btn.dataset.oneTimeQty ||
        btn.dataset.qty,
        1
      );


    if (!oneTimeVariantId) {

      console.warn(
        'One-time checkout has no variant ID'
      );

      return;
    }


    btn.dataset.type =
      'oneTime';

    btn.dataset.variantId =
      oneTimeVariantId;

    btn.dataset.spId =
      '';

    btn.dataset.qty =
      oneTimeQty;


    console.log(
      'Checkout kept as ONE-TIME:',
      {
        type: 'oneTime',
        variantId: oneTimeVariantId,
        sellingPlanId: '',
        qty: oneTimeQty
      }
    );


    return;
  }


  /*
   * =======================================================
   * SUBSCRIPTION MODE
   * =======================================================
   */

  const selectedOption =
    document.querySelector(
      '.custom-subscription-btn.is-selected'
    );


  if (!selectedOption) {

    console.warn(
      'No selected subscription option found'
    );

    return;
  }


  const variantId =
    selectedOption.dataset.variantId;


  const sellingPlanId =
    selectedOption.dataset.sellingPlanId ||
    '';


  const qty =
    getSubscriptionQuantity(
      selectedOption.dataset.qty,
      1
    );


  /*
   * Keep normalized quantity synced.
   */
  selectedOption.dataset.qty =
    qty;


  if (!variantId) {

    console.warn(
      'Selected subscription option has no variant ID'
    );

    return;
  }


  btn.dataset.type =
    'subscribe';

  btn.dataset.variantId =
    variantId;

  btn.dataset.spId =
    sellingPlanId;

  btn.dataset.qty =
    qty;


  /*
   * Clear one-time state when
   * subscription becomes active.
   */
  btn.dataset.oneTimeVariantId =
    '';

  btn.dataset.oneTimeQty =
    '';


  console.log(
    'Checkout updated:',
    {
      type: 'subscribe',
      variantId: variantId,
      sellingPlanId: sellingPlanId,
      qty: qty
    }
  );
}


/* =========================================================
   ADD TO CHECKOUT
========================================================= */

document.addEventListener(
  'click',
  function (e) {

    const btn =
      e.target.closest(
        '#add-to-checkout'
      );


    if (!btn) {
      return;
    }


    e.preventDefault();
    e.stopPropagation();


    /*
     * Read the CURRENT state directly
     * from the checkout button.
     */
    const type =
      btn.dataset.type ||
      'subscribe';


    const vId =
      btn.dataset.variantId;


    const spId =
      type === 'subscribe'
        ? (btn.dataset.spId || '')
        : '';


    const qty =
      getSubscriptionQuantity(
        btn.dataset.qty,
        1
      );


    if (!vId) {

      console.error(
        'No variant ID selected'
      );

      return;
    }


    console.log(
      'FINAL ADD TO CART:',
      {
        type: type,
        variantId: vId,
        sellingPlanId: spId,
        quantity: qty
      }
    );


    addToCartAndCheckout(
      type,
      vId,
      spId,
      qty
    );
  }
);


/* =========================================================
   ADD TO CART + CART DRAWER
========================================================= */

function addToCartAndCheckout(
  type,
  vId,
  spId,
  qty
) {

  const btn =
    document.getElementById(
      'add-to-checkout'
    );


  const ctaText =
    document.getElementById(
      'product-final-price-cta-text'
    );


  if (!btn || !ctaText) {
    return;
  }


  if (btn.disabled) {
    return;
  }


  if (!ctaText.dataset.originalText) {

    ctaText.dataset.originalText =
      ctaText.textContent.trim();
  }


  ctaText.textContent =
    'Adding...';


  btn.classList.add(
    'loading'
  );


  btn.setAttribute(
    'aria-busy',
    'true'
  );


  btn.disabled = true;


  /*
   * Get final quantity.
   */
  const finalQty =
    getSubscriptionQuantity(
      qty,
      1
    );


  const payload = {
    id: vId,
    quantity: finalQty
  };


  /*
   * Only subscription adds
   * should contain selling_plan.
   */
  if (
    type === 'subscribe' &&
    spId
  ) {

    payload.selling_plan =
      spId;
  }


  console.log(
    'Adding to cart:',
    {
      type: type,
      payload: payload
    }
  );


  fetch(
    '/cart/add.js',
    {
      method: 'POST',

      headers: {
        'Content-Type':
          'application/json'
      },

      body: JSON.stringify(
        payload
      )
    }
  )

    .then(res => {

      if (!res.ok) {

        throw new Error(
          'Add to cart failed'
        );
      }


      return res.json();
    })

    .then(() => {

      /*
       * Open cart drawer after
       * successful add.
       */
      refreshCartDrawer();
    })

    .catch(err => {

      console.error(
        'Add to cart failed:',
        err
      );


      alert(
        'Unable to add item to cart. Please try again.'
      );
    })

    .finally(() => {

      ctaText.textContent =
        ctaText.dataset.originalText;


      btn.classList.remove(
        'loading'
      );


      btn.removeAttribute(
        'aria-busy'
      );


      btn.disabled = false;
    });
}


/* =========================================================
   REFRESH CART DRAWER
========================================================= */

function refreshCartDrawer() {

  const $cartDrawer =
    $('.drawer');


  if (!$cartDrawer.length) {

    console.error(
      'Cart drawer element not found!'
    );

    return;
  }


  $cartDrawer
    .removeClass('is-empty')
    .addClass('active')
    .load(
      '/cart?view=drawer #CartDrawer',
      function () {

        document.body.classList.add(
          'cart-open'
        );
      }
    );
}


/* =========================================================
   GALLERY THUMBNAIL CLICK
========================================================= */

document.addEventListener(
  'click',
  function (e) {

    const thumb =
      e.target.closest(
        '.gallery-thumb'
      );


    if (!thumb) {
      return;
    }


    const gallery =
      thumb.closest(
        '.product-gallery'
      );


    if (!gallery) {
      return;
    }


    const index =
      thumb.dataset.index;


    const mainSlides =
      gallery.querySelectorAll(
        '.gallery-image'
      );


    const thumbs =
      gallery.querySelectorAll(
        '.gallery-thumb'
      );


    mainSlides.forEach(img => {

      img.classList.remove(
        'active'
      );
    });


    thumbs.forEach(t => {

      t.classList.remove(
        'active'
      );
    });


    const activeSlide =
      gallery.querySelector(
        `.gallery-image[data-index="${index}"]`
      );


    if (activeSlide) {

      activeSlide.classList.add(
        'active'
      );
    }


    thumb.classList.add(
      'active'
    );
  }
);


/* =========================================================
   THUMB ARROWS
========================================================= */

$(document).on(
  'click',
  '.thumb-arrow',
  function () {

    const $gallery =
      $(this).closest(
        '.product-gallery'
      );


    const $slider =
      $gallery.find(
        '.custom-thumb-slider'
      );


    const $item =
      $slider
        .find('.gallery-thumb')
        .first();


    if (
      !$slider.length ||
      !$item.length
    ) {

      return;
    }


    const slideWidth =
      $item.outerWidth(true);


    if (
      $(this).hasClass('left')
    ) {

      $slider.animate(
        {
          scrollLeft:
            $slider.scrollLeft() -
            slideWidth
        },
        300
      );
    }


    if (
      $(this).hasClass('right')
    ) {

      $slider.animate(
        {
          scrollLeft:
            $slider.scrollLeft() +
            slideWidth
        },
        300
      );
    }
  }
);


/* =========================================================
   VARIANT → GALLERY
========================================================= */

document.addEventListener(
  'click',
  function (e) {

    const btn =
      e.target.closest(
        '.custom-variant-btn'
      );


    if (!btn) {
      return;
    }


    const mediaId =
      btn.dataset.mediaId;


    if (!mediaId) {
      return;
    }


    const gallery =
      $('.product-gallery')[0];


    if (!gallery) {
      return;
    }


    updateGalleryByMedia(
      mediaId,
      gallery
    );
  }
);


/* =========================================================
   UPDATE GALLERY BY MEDIA
========================================================= */

function updateGalleryByMedia(
  mediaId,
  gallery
) {

  if (!gallery) {
    return;
  }


  const images =
    gallery.querySelectorAll(
      '.gallery-image'
    );


  const thumbs =
    gallery.querySelectorAll(
      '.gallery-thumb'
    );


  images.forEach(img => {

    img.classList.remove(
      'active'
    );
  });


  thumbs.forEach(thumb => {

    thumb.classList.remove(
      'active'
    );
  });


  const activeImage =
    gallery.querySelector(
      `.gallery-image[data-media-id="${mediaId}"]`
    );


  const activeThumb =
    gallery.querySelector(
      `.gallery-thumb[data-media-id="${mediaId}"]`
    );


  if (activeImage) {

    activeImage.classList.add(
      'active'
    );
  }


  if (activeThumb) {

    activeThumb.classList.add(
      'active'
    );


    activeThumb.scrollIntoView({
      behavior: 'smooth',
      inline: 'center',
      block: 'nearest'
    });
  }
}


/* =========================================================
   INITIAL LOAD FALLBACK
========================================================= */

document.addEventListener(
  'DOMContentLoaded',
  function () {

    setTimeout(
      function () {

        initializeSubscriptionSelection(
          document
        );

      },
      300
    );
  }
);